export const powerOptions = [
  ["base feed", "base feed"],
  ["top feed", "top feed"]
];

export const predefinedCubicFeetOptions = [
  "1.2 Carton",
  "1.5 Carton",
  "2.4 Carton",
  "3.0 Carton",
  "4.5 Carton",
  "6.0 Carton",
].map(v => [v, v]);

export const billingTypeOptions = [
  "Hundredweight",
  "By the Pallet",
  "By the Pallet (Warehouse-Built)",
  "By the Unit/Item",
  "By the Vault",
  "Square Foot by Item Dimensions",
  "Square Foot by Location Dimensions",
  "Cubic Foot by Item Dimensions",
  "Cubic Foot by Location Dimensions",
  "Storage Locations Occupied",
  "Flat Rate/As Quoted",
].map(v => [v, v]);
